var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.arr),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[(item.type == 'mp4' || item.type == 'mov')?_c('video',{attrs:{"src":item.url,"controls":"controls","autoplay":false}}):(
                    item.type == 'jpg' ||
                    item.type == 'png' ||
                    item.type == 'jpeg' ||
                    item.type == 'svg' ||
                    item.type == 'webp' ||
                    item.type == 'jfif'
                )?_c('img',{attrs:{"src":item.url,"alt":""}}):_vm._e()])}),0),_c('div',{staticClass:"swiper-pagination"}),_c('div',{staticClass:"swiper-button-next"}),_c('div',{staticClass:"swiper-button-prev"})])
}
var staticRenderFns = []

export { render, staticRenderFns }